export const AUTH_TOKEN_KEY = "__credithub__token";
export const AUTH_USER_KEY = "__credithub__user";

export const systemRoles = {
  contacts: {
    view: "contacts_view",
    edit: "contacts_edit",
    chc: "contacts_chc",
    teams: "contacts_teams",
  },
};
export const availableRoles = ["participant_super_user", "nin_verifier"];
export const resourceGroups: { [roleName: string]: string[] } = {
  participant_super_user: [
    "IdVerification",
    "users",
    "settings",
    "help",
    "devPortal",
    "export",
  ],
  nin_verifier: ["IdVerification", "help"],
};
export const redux = {
  doLogin: "DO_LOGIN",
  doLogout: "DO_LOGOUT",
  doSearch: "DO_SEARCH",
};

export const localRoutes = {
  callback: "/callback",
  pending: "/pending",
  ninVerification: "/verification",
  participantsDetails: "/participants/:participantId/:subSection",
  participants: "/participants",
  billing: "/billing",
  subscriptions: "/subscriptions",
  reports: "/reports",
  devPortal: "/developer-portal",
  applicationsDetails: "/applications/:caseId",
  dashboard: "/dashboard",
  contacts: "/contacts",
  contactsDetails: "/contacts/:contactId",
  settings: "/settings",
  users: "/users",
  usersDetails: "/users/:userId",
  help: "/help",
};

const evVar = process.env.NODE_ENV || "dev";
const environment = evVar.trim();
export const API_VERSION = "?v=2.0";
export const APPLICATIONS_API_VERSION = "v1";
export const APIM_VERSION = "1.0";

console.log(
  `############# Env : ${environment} | API VERSION: ${API_VERSION} ###############`
);

export const env = {
  Auth: process.env.REACT_APP_Auth,
  Nin: process.env.REACT_APP_Nin,
  Onboarding: process.env.REACT_APP_Onboarding,
  Application: process.env.REACT_APP_Application,
  devPortal: process.env.REACT_APP_DEVPORTAL,
  clientId: process.env.REACT_APP_clientId,
  envScope: process.env.REACT_APP_envScope,
  Crm: process.env.REACT_APP_CRM,
  Gateway: process.env.REACT_APP_Gateway,
  docgenerator: process.env.REACT_APP_DOCGENERATOR,
  csvExport: process.env.REACT_APP_CSVEXPORT,
  BNV: process.env.REACT_APP_BNV,
  Routing: process.env.REACT_APP_ROUTING,
  Kyc: process.env.REACT_APP_KYC,
  docStore: process.env.REACT_APP_DOCSTORE,
  Environment: process.env.REACT_APP_ENV ?? undefined,
  SbiEnv: process.env.REACT_APP_SBI_ENV,
  SbiPurpose: process.env.REACT_APP_SBI_PURPOSE,
  SbiSpecVersion: process.env.REACT_APP_SBI_SPEC_VERSION,
  SbiTimeout: process.env.REACT_APP_SBI_TIMEOUT,
  SbiDomainUri: process.env.REACT_APP_SBI_DOMAIN_URI,
  SbiRequestedScore: process.env.REACT_APP_SBI_REQUESTED_SCORE,
  APIM: process.env.REACT_APP_APIM,
  skey: process.env.REACT_APP_SKEY,
  OnboardingGateway: process.env.REACT_APP_ONBOARDING_GATEWAY,
  ingestor: process.env.REACT_APP_INGESTOR
};

export const remoteRoutes = {
  ninVerificationId: env.Nin + "/api/request" + API_VERSION,
  idvRequests: env.Nin + "/api/workflows",
  onboardingRequests: env.Nin + "/api/workflows",
  ninRequests: env.Nin + "/api/requests" + API_VERSION,
  ninVerificationRequests: env.Nin + "/api/request/search" + API_VERSION,
  ninVerification: env.Nin + "/api/national-id/verify" + API_VERSION,
  niraNotification: env.Nin + "/health",
  niraExport: env.Nin + "/api/exports/",
  niraCredentials: env.Nin + "/api/credentials" + API_VERSION,
  niraCurrentCredentials: env.Nin + "/api/credentials/current" + API_VERSION,
  webSockets: env.APIM + "/hubs/checkhub",
  webSocketsKYC: env.APIM + "/hubs/checkhub",
  webSocketsCRM: env.APIM + "/hubs/customerprofilehub",
  webSocketsCSV: env.APIM + "/hubs/csvexporthub",
  webSocketsAT: env.APIM + "/hubs/latestauditshub",
  authServer: env.Auth,
  login: env.Auth + "/api/test/login",
  profile: env.Auth + "/api/test/profile",
  register: env.Auth + "/api/auth/register",
  resetPass: env.Auth + "/reset",
  users: env.Auth + "/api/user",
  devPortal: env.devPortal,
  CSVgenerator: env.APIM,
  docStoreFiles: env.APIM + "doc-store/api/docs/download",
  docStore: env.APIM + 'doc-store/api/docs/', // on-prem
  markAsReviewed: env.Nin + "/api/manual",
  kyc: env.APIM + "kyc/api/verifications", // on-prem
  PDFgenerator: env.APIM + "doc-generator/api/pdfs?v=" + APIM_VERSION,
  bnv: env.APIM + "verify-business/api/",
  crm: env.APIM + "crm/api/" + APPLICATIONS_API_VERSION, // on-prem
  co: env.APIM + "onboarding/api/" + APPLICATIONS_API_VERSION + "/applications", // on-prem
  onboardingGateway: env.OnboardingGateway + "/api",
  routing: env.APIM + 'routing/' + APPLICATIONS_API_VERSION, // on-prem
  applicationRequests: env.APIM + "onboarding/api/" + APPLICATIONS_API_VERSION + "/applications",
  auditTrail: env.APIM + "audit-trail/api/audits/entities/",
  notifications: env.APIM + "notification/api/communications",
  bulk: env.APIM + "kyc/api/",
  excelTemplate: env.APIM + "routing/api",
  submissions: env.ingestor + "api/v1",
  mosip: env.ingestor + "api/requests/kyc",
  oldIdv: env.ingestor + "api/requests",
};

export const accountTypes = ["Savings account", "Current account"];

export const HOUSELINKS = {
  main: "https://www.bou.or.ug/",
  about: "https://www.bou.or.ug/",
  support: "https://www.bou.or.ug/",
  legal: "https://www.bou.or.ug/",
  merchantConsole: 'https://www.bou.or.ug/',
  userConsole: 'https://www.bou.or.ug/'
};

export const DOCUMENT_TYPES = [
  'National ID', 'Passport Photo', 'Other'
]

export const DOCUMENT_DESCRIPTION = [
  'ID Photo Back', 'ID Photo Front', 'Customer Passport Photo', 'Other'
]

export const VALIDATION_STEPS = [
  {
    name: 'Uploading ID document for processing',
    status: 'done',
  },
  {
    name: 'Extracting data from ID image via OCR',
    status: 'inProgress',
  },
  {
    name: 'Checking ID authenticity & security features',
    status: 'pending',
  },
  {
    name: 'Almost done! Loading results...',
    status: 'pending',
  },
]

export const COMPANY_DOCUMENT_TYPES = [
  'Annual Returns', 'Company Resolution', 'Form', 'Certificate', 'Transfer of shares', 'Correspondence', 'Unclassified', 'Other'
]

export const CHECKS_OFFLINE_MESSAGE = "Service is unreachable at the moment. We appreciate your understanding while we address a temporary disruption. Please try again later."

export const PERSON_CHECKS_OFFLINE = process.env.REACT_APP_PERSON_CHECKS_OFFLINE ? JSON.parse(process.env.REACT_APP_PERSON_CHECKS_OFFLINE) : {}
export const DISABLE_RISK_PROFILING = process.env.REACT_APP_DISABLE_RISK_PROFILING ? JSON.parse(process.env.REACT_APP_DISABLE_RISK_PROFILING) : []

export const defaultImageBase56 =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAECAYAAABCxiV9AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAYSURBVBhXY5STk/vPgAMwQWmsgFxJBgYAmegBYR4uUFEAAAAASUVORK5CYII=";
